export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";